export const routesName = {
  404: '/*',
  home: '/',
  about: '/about',
  tenders: '/tenders',
  my_tenders: '/my-tenders',
  contact: '/contact',
  pricing: '/pricing',
  ngounStaff: '/ngo-un-staff',
  termsAndConditions: '/terms-conditions',
  login: '/auth/sign-in',
  forgotPassword: '/auth/forgot-password',
  signupOption: '/auth/sign-up/options',
  signupSupplier: '/auth/sign-up/supplier',
  signupBuyer: '/auth/sign-up/buyer',
  resetPassword: '/resetPassword/:token',
  dashboard: '/dashboard',
  tenderListing: '/tenders/all',
  myTenderListing: '/tenders/my',
  editTender: '/tenders/edit/:id',
  editTenderPath: '/tenders/edit/',
  createTender: '/tenders/create',
  viewTender: '/tenders/view/:id',
  viewTenderPath: '/tenders/view/',
  downloadBid: '/tenders/bid/download/:id',
  downloadBidPath: '/tenders/bid/download/',
  unreadMessages: '/messages/unread',
  chats: '/chats',
  openChat: '/chats/open',
};
